<!-- 个人账号权限开通或变更申请表 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>
		
		<Spin size="large" fix v-if="spinShow"></Spin>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import wx from 'weixin-js-sdk'
	import Textarea from '../components/Textarea.vue';

	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
    import { submitProcess } from '@/api/approval'
	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	import {
			formatDate
		} from '@/utils/date'
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				"templateData": templateData,
				spinShow:true,
				spNo: null
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			this.getTemplate();
			stringUtils.setAddIsShow(false);
			this.spNo = this.$route.query.spNo;
		},
		created() {
		},
		methods: { //方法
			
			getTemplate:async function()  {
				let that = this;
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.JobLevel <= 6 ? 1 : 2;
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
						}  else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请内容") {
							that.templateData.TemplateContent.Controls[i].Config.Table.Children.forEach(async (item) =>{
								if(item.Property.Title[0].Text == "备注说明"){
									item.Value = "按揭金融服务中心开通权限:\n按揭/金融/签约专员:1.经纪服务合同签约权限 2.买卖网签合同权限。\n"+
									"住宅部开通权限:\n 店董开通:1.买卖房源发布权限 2.租赁房源发布权限 3.经济服务合同签约权限。\n"+
									" 除开店董外开通:1买卖房源发布权限 2.租赁房源发布权限。";
									item.Disable = true;
								}
							})
						} 
					}
					that.templateData = await this.assignControlBySpNo(res.data.Body, this.spNo);
					that.spinShow = false;
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val) {
				var templateId = stringUtils.GetQueryString("templateId");
				var controls = this.templateData.TemplateContent.Controls;
				var i = 0;
				if (templateId == 'Bs7xbzNAeeBPD3ttT37HHJRe4KRc3bA5wURd7xTME') {
					// 是员工人事类盖章审批申请
					if (val == 'option-1595832288661' || val == 'option-1595832288662' || val == 'option-1595832288663') {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 1;
								return;
							}
						}
					} else {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 0;
								return;
							}
						}
					}
				}
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0]
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0]
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+" "+control1.Value+" "+control2.Value+" "+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control5=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请类别"})[0]
				var control5Text=control5.Config.Selector.Options.filter(t=>{return t.Key==control5.Value})[0].Value[0].Text;
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请类别："+control5Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				
				// //提交
				submitProcess(stringUtils.GetQueryString("templateId"), logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					console.log(response);
					isSubmit = false;
					this.$router.push("/index");
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
